const pageTabs = new Map<string, string>();

export function updateTabCache(page: string, tab: string) {
    pageTabs.set(page, tab);
}

export function getTabCache(page: string) {
    return pageTabs.get(page);
}